import * as React from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { PolicyEditorController } from 'src/app/bookings/policies/parts/policy-editor.controller';
import { CardController } from 'src/app/shared/card.controller';
import { ZuluIcon } from 'src/app/shared/icon';

interface Props extends ComponentViewProps<DataSet<AgentPolicyItem>> {
	onCreateAgentPolicy: () => Promise<AgentPolicyItem>;
	swapDownPriorities: (index: number) => void;
	mode: ControlMode;
}

@observer
export class AgentPolicyView extends React.Component<Props, {}> {
	columns: Column[] = [
		{
			title: '',
			key: 'index',
			width: '20px',
			render: (text, record, index) => {
				const { mode, model, swapDownPriorities } = this.props;
				return (
					<div>
						{
							index > 0 &&
							<div>
								<Button
									disabled={mode === 'display'}
									size="small"
									onClick={() => swapDownPriorities(index)}>
									<ZuluIcon type="caret-up" />
								</Button>
							</div>
						}
						{
							index < (model.count - 1) &&
							<div>
								<Button
									disabled={mode === 'display'}
									size="small"
									onClick={() => swapDownPriorities(index + 1)}>
									<ZuluIcon type="caret-down" />
								</Button>
							</div>
						}
					</div>
				);
			}
		},
		{
			key: 'policyName',
			dataIndex: 'policyName',
			title: 'Name',
			editable: (text: string, record: AgentPolicyItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<PolicyEditorController
							required
							label={null}
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							value={record.policyId}
							onChange={(item) => {
								record.policyId = item.id;
								record.policyName = item.displayName;
							}}
						/>
					);
				}

				return <span>{text}</span>;
			}
		}
	];

	render(): React.ReactNode {
		const { model, onCreateAgentPolicy, mode, setBusy } = this.props;
		if (this.props.model == null) {
			return null;
		}

		return (
			<CardController
				title="Policies"
				icon="sliders"
				className="card-borderless"
				mode={mode}>
				<DataTableView
					model={model}
					columns={this.columns}
					createNewItem={onCreateAgentPolicy}
					mode={mode}
					setBusy={setBusy}
					hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hidePagination}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-policies/agent-policy.view.tsx